import { Divider, Grid, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { ClientPortalContext } from '../../ClientPortal'
import moment from 'moment'

const Documents = () => {
  const { organisation } = useContext(ClientPortalContext)
  return (
    <Grid item xs={12} md={6} lg={4}>
      <Stack gap={1}>
        <Typography variant="title2">Documents</Typography>
        <Stack gap={1} divider={<Divider />}>
          {organisation?.engagementLetters?.map((letter, index) => {
            if (moment(letter.start).isAfter(moment())) {
              return null
            } else if (
              moment(letter.end).isBefore(moment().subtract(3, 'months'))
            ) {
              return null
            } else {
              return (
                <Stack
                  key={index}
                  direction="row"
                  justifyContent="space-between"
                >
                  Engagement Letter
                </Stack>
              )
            }
          })}
        </Stack>
      </Stack>
    </Grid>
  )
}

export default Documents
